import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ColumnGroup, Column, Card } from '@cards/Card';
import { usePageActions } from '@hooks';
import { selectOrganisation } from '@redux/organisations/reducers';

import { loadOrgConfig } from '@integrations/redux/actions';
import { selectOrgConfig } from '@integrations/redux/reducers';
import './style.less';

function View() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [hasLoaded, setHasLoaded] = useState(false);

  const dashboardUserProfile = useSelector(state => state.login.user.profile);
  const [, organisation] = useSelector(selectOrganisation(dashboardUserProfile.organisationId));
  const [, orgConfig] = useSelector(selectOrgConfig('mixpanel'));

  let dashboardURL = '';
  if (orgConfig && orgConfig.isEnabled && orgConfig.data.dashboard_url) {
    dashboardURL = orgConfig.data.dashboard_url;
  }

  const { setTitle } = usePageActions({
    title: '',
    actions: [],
    showClose: false,
  });

  useEffect(() => {
    const name = (organisation && organisation.name) || '';
    setTitle(name);
    document.title = name;
  }, [organisation, setTitle]);

  useEffect(() => {
    if (hasLoaded || !organisation) {
      return;
    }
    dispatch(loadOrgConfig('mixpanel'));
    setHasLoaded(true);
  }, [dispatch, hasLoaded, setHasLoaded, organisation]);

  return (
    <ColumnGroup className="edit-organisation-branding-details">
      <Column>
        {dashboardURL ? (
          <iframe
            src={dashboardURL}
            style={{ minHeight: '1080px' }}
            title={t('mixpanel:organisationConfig.viewTitle')}
          ></iframe>
        ) : (
          <Card className="organisation-details-form-card" title={t('mixpanel:view.noConfigTitle')}>
            <p>{t('mixpanel:view.noConfigDescription')}</p>
          </Card>
        )}
      </Column>
    </ColumnGroup>
  );
}

export default View;
